var map = {
	"./b1.png": 8558,
	"./b10.png": 9772,
	"./b2.png": 4309,
	"./b3.png": 2044,
	"./b4.png": 8291,
	"./b5.png": 4186,
	"./b6.png": 5297,
	"./b7.png": 1432,
	"./b8.png": 1279,
	"./b9.png": 7990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8761;